// import React, { useRef, useEffect, useState } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { useGSAP } from '@gsap/react';

// gsap.registerPlugin(ScrollTrigger, useGSAP);

// const SplitText = ({
//   text,
//   className = '',
//   delay = 100,
//   duration = 0.6,
//   ease = 'power3.out',
//   from = { opacity: 0, y: 40 },
//   to = { opacity: 1, y: 0 },
//   threshold = 0.1,
//   rootMargin = '-100px',
//   textAlign = 'center',
//   tag = 'p',
//   onLetterAnimationComplete
// }) => {
//   const ref = useRef(null);
//   const [isLoaded, setIsLoaded] = useState(false);

//   useEffect(() => {
//     // Fallback: Jika font lama dimuat, paksa tampil setelah 200ms
//     const timer = setTimeout(() => {
//       setIsLoaded(true);
//     }, 200);

//     if (document.fonts?.ready) {
//       document.fonts.ready.then(() => {
//         clearTimeout(timer);
//         setIsLoaded(true);
//       });
//     }

//     return () => clearTimeout(timer);
//   }, []);

//   useGSAP(() => {
//     if (!ref.current || !isLoaded) return;

//     const el = ref.current;
//     el.innerHTML = ''; // Bersihkan konten lama

//     const words = text.split(' ');
//     const charElements = [];

//     words.forEach((word, i) => {
//       const wordSpan = document.createElement('span');
//       wordSpan.style.display = 'inline-block';
//       wordSpan.style.whiteSpace = 'pre';

//       const chars = word.split('');
//       chars.forEach((char) => {
//         const charSpan = document.createElement('span');
//         charSpan.textContent = char;
//         charSpan.style.display = 'inline-block';
//         // Kita set opacity awal lewat GSAP, bukan style inline agar tidak flash
//         charElements.push(charSpan);
//         wordSpan.appendChild(charSpan);
//       });

//       el.appendChild(wordSpan);

//       if (i < words.length - 1) {
//         const spaceSpan = document.createElement('span');
//         spaceSpan.innerHTML = '&nbsp;';
//         spaceSpan.style.display = 'inline-block';
//         el.appendChild(spaceSpan);
//       }
//     });

//     const startPct = (1 - threshold) * 100;

//     gsap.fromTo(
//       charElements,
//       { ...from },
//       {
//         ...to,
//         duration: duration,
//         ease: ease,
//         stagger: delay / 1000,
//         scrollTrigger: {
//           trigger: el,
//           start: `top 95%`, // Trigger lebih awal (saat elemen sedikit masuk layar)
//           end: 'bottom top',
//           toggleActions: 'play none none reverse',
//         },
//         onComplete: () => {
//           if (onLetterAnimationComplete) onLetterAnimationComplete();
//         }
//       }
//     );

//   }, [text, isLoaded, delay, duration, ease, threshold]);

//   const Tag = tag;

//   // Default style opacity 1 agar jika JS gagal, teks tetap terbaca
//   return (
//     <Tag 
//       ref={ref} 
//       className={className} 
//       style={{ textAlign: textAlign, width: '100%', opacity: isLoaded ? 1 : 0, transition: 'opacity 0.2s' }}
//     >
//       {!isLoaded ? text : null}
//     </Tag>
//   );
// };

// export default SplitText;

import React, { useRef, useEffect, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger, useGSAP);

const SplitText = ({
  text,
  className = '',
  delay = 100,
  duration = 0.6,
  ease = 'power3.out',
  from = { opacity: 0, y: 40 },
  to = { opacity: 1, y: 0 },
  threshold = 0.1,
  rootMargin = '-100px',
  textAlign = 'center',
  tag = 'p',
  onLetterAnimationComplete
}) => {
  const ref = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Fallback: Jika font lama dimuat, paksa tampil setelah 200ms
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 200);

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        clearTimeout(timer);
        setIsLoaded(true);
      });
    }

    return () => clearTimeout(timer);
  }, []);

  useGSAP(() => {
    if (!ref.current || !isLoaded) return;

    const el = ref.current;
    el.innerHTML = ''; // Bersihkan konten lama

    // Pastikan text ada sebelum split
    if (!text) return;

    const words = text.split(' ');
    const charElements = [];

    words.forEach((word, i) => {
      const wordSpan = document.createElement('span');
      wordSpan.style.display = 'inline-block';
      wordSpan.style.whiteSpace = 'pre';

      const chars = word.split('');
      chars.forEach((char) => {
        const charSpan = document.createElement('span');
        charSpan.textContent = char;
        charSpan.style.display = 'inline-block';
        // Kita set opacity awal lewat GSAP, bukan style inline agar tidak flash
        charElements.push(charSpan);
        wordSpan.appendChild(charSpan);
      });

      el.appendChild(wordSpan);

      if (i < words.length - 1) {
        const spaceSpan = document.createElement('span');
        spaceSpan.innerHTML = '&nbsp;';
        spaceSpan.style.display = 'inline-block';
        el.appendChild(spaceSpan);
      }
    });

    const startPct = (1 - threshold) * 100;

    gsap.fromTo(
      charElements,
      { ...from },
      {
        ...to,
        duration: duration,
        ease: ease,
        stagger: delay / 1000,
        scrollTrigger: {
          trigger: el,
          start: `top 95%`, // Trigger lebih awal (saat elemen sedikit masuk layar)
          end: 'bottom top',
          toggleActions: 'play none none reverse',
        },
        onComplete: () => {
          if (onLetterAnimationComplete) onLetterAnimationComplete();
        }
      }
    );

  }, [text, isLoaded, delay, duration, ease, threshold]);

  const Tag = tag;

  // Tambahkan class 'notranslate' agar Google Translate tidak merusak struktur DOM animasi ini
  return (
    <Tag
      ref={ref}
      className={`${className} notranslate`}
      translate="no"
      style={{ textAlign: textAlign, width: '100%', opacity: isLoaded ? 1 : 0, transition: 'opacity 0.2s' }}
    >
      {!isLoaded ? text : null}
    </Tag>
  );
};

export default SplitText;